

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      totalNeto:0,
      lista_terminales:[],
      ventas: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -7),
        hasta: this.currentdate(),
        terminal: ''
      }

    };
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      "autoWidth": false,
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,


    });
    $('.box').boxWidget();
    this.getListaTerminales()
  },


  computed: {
    reporte: function () {
      return (
        "/loteip/informe/vendedor?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&terminal=" +
        this.f_c.terminal
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/loteip/informe/vendedor', this.f_c)
        .then(response => {

          if (response.data.status == 1) {

            this.totalNeto=response.data.totalNeto;
            
            for (let i = 0; i < response.data.data.length; i++) {
              response.data.data[i][6] = this.num_to_many(parseFloat(response.data.data[i][6]).toFixed(2));
              response.data.data[i][7] = this.num_to_many(parseFloat(response.data.data[i][7]).toFixed(2));
              response.data.data[i][8] = this.num_to_many(parseFloat(response.data.data[i][8]).toFixed(2));
              response.data.data[i][9] = this.num_to_many(parseFloat(response.data.data[i][9]).toFixed(2));
              this.tbv.row.add(response.data.data[i]);
            }
          }
          this.tbv.draw();
          this.loading = false;
        });

    },

    getListaTerminales() {
      this.lista_terminales = [];
      this.$http
        .post('/loteip/lista/terminales', this.f_c)
        .then(response => {
          this.lista_terminales = response.data.data;
          
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/posintegrado/informeVendedor/tventas/tventas.js